import { atom } from 'ximple';

interface AddIdAction {
    type: 'Add';
    value: string;
}

interface RemoveIdAction {
    type: 'Remove';
    value: string;
}

type Actions = AddIdAction | RemoveIdAction;

// The purpose of this atom is to keep track of the id's of
// Modal-component-instances that are mounted, by adding
// them to an array, and removing when destroyed/unmounted.
export const modalAtom = atom<string[], Actions>({
    initialValue: [],
    update: (state: string[], action: Actions) => {
        switch (action.type) {
            case 'Add':
                if (!state.includes(action.value)) return [...state, action.value];

                break;
            case 'Remove':
                const index = state.indexOf(action.value);
                if (index !== -1) {
                    const newState = [...state];
                    newState.splice(index, 1);
                    return newState;
                }

                break;
        }

        return state;
    },
});

export function addId(value: AddIdAction['value']): AddIdAction {
    return { type: 'Add', value };
}

export function removeId(value: RemoveIdAction['value']): RemoveIdAction {
    return { type: 'Remove', value };
}

// Check if `id` is the first in array.
export function isFirst(state: string[], id: string) {
    return state[0] === id;
}
